import type { Layer, TagsManager } from 'dxf-writer'
import DatabaseObject from 'dxf-writer/src/DatabaseObject.js'
import type Handle from 'dxf-writer/src/Handle.js'

type BlockShape = {
  layer?: Layer
  ownerObjectHandle?: string
  tags: (manager: TagsManager) => void
}

/**
 * DXF 块（BLOCK）定义，聚合一组形状并在 BLOCKS 段落中整体写出。
 */
export default class Block extends DatabaseObject {
  /** 对应的 ENDBLK 结束对象 */
  end: DatabaseObject
  /** 关联的 BLOCK_RECORD 句柄，插入 model space 时由外部填充 */
  recordHandle: string | null
  /** 块内形状列表 */
  shapes: BlockShape[] = []
  /** 块对象自身句柄 */
  handle: Handle

  constructor(
    public name: string,
    public flag = 1, // 块类型标志 1-匿名块
    public basePoint: { x: number; y: number } = { x: 0, y: 0 }
  ) {
    super(['AcDbEntity', 'AcDbBlockBegin'])
    this.end = new DatabaseObject(['AcDbEntity', 'AcDbBlockEnd'])
    this.recordHandle = null
  }

  /**
   * 追加一个形状到块定义。
   *
   * @param shape - 需要写入块内的实体
   */
  addShape(shape: BlockShape) {
    this.shapes.push(shape)
  }

  /**
   * 写入 BLOCK 起始、内部形状以及 ENDBLK 组码序列。
   *
   * @param manager - DXF 标签写入器
   */
  tags(manager: TagsManager) {
    manager.push(0, 'BLOCK')
    super.tags(manager)
    manager.push(2, this.name)
    manager.push(70, this.flag)
    /* 基点 */
    manager.point(this.basePoint.x, this.basePoint.y)
    manager.push(3, this.name)
    /* xref path name - nothing */
    manager.push(1, '')

    const ownerHandle = this.recordHandle || this.handle
    for (const shape of this.shapes) {
      shape.ownerObjectHandle = ownerHandle
      shape.tags(manager)
    }

    manager.push(0, 'ENDBLK')
    this.end.tags(manager)
  }
}
